import styled, { css } from 'styled-components'
import { theme, media } from '../../styles/_variables'
import { WidthContainer as Wc } from '../../components/container/styled'

export const WidthContainer = styled(Wc)`
  padding: 40px 16px;
  ${media.tablet`
    padding: 24px 16px;
  `}
`

export const ContentContainer = styled.div`
  margin: 0 0 0 32px;
  width: 100%;
  overflow: auto;
  ${props => props.overflowHidden && css`
    overflow: hidden;
    padding-bottom: 16px;
    ${media.laptopXL`
      overflow: hidden;
    `}
    ${media.laptopL`
      width: auto;
      overflow: hidden;
    `}
    ${media.laptop`
      overflow: hidden;
    `}
  `}
  ${media.tablet`
    margin: 40px 0 0;
  `}
`

export const TabContainerWrapper = styled.div`
  display: flex;
  ${media.tablet`
    flex-direction: column;
    ${props => props.title && css`
      > div:first-child {
        position: relative;
        display: flex;
        flex-direction: row;
        border-bottom: 1px solid ${theme.color.lightPaleGrey};
        &::after {
          content: '';
          ${props.title && css`
            content: '${props.title}';
          `}
          white-space: nowrap;
          transition: left 0.5s ease;
          font-size: ${theme.fonts.size.small};
          color: transparent;
          border-bottom: 1px solid ${theme.color.primaryColor};
          position: absolute;
          bottom: 0;
          left: ${props.activeTab === 1 ? 0 : props.activeTab === 2 ? '141px' : '452px'};
        }
      }
    `}
  `}
  ${media.mobileM`
    > div:first-child {
      &::after {
        left: ${props => (props.activeTab === 1 ? 0 : props.activeTab === 2 ? '133px' : '439px')};
      }
    }
  `}
`

export const TabTitleWrapper = styled.div`
  border: 1px solid ${theme.color.paleGray};
  padding: 6px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  min-width: 240px;
  > h4 {
    color: ${props => (props.color ? props.color : theme.color.lightGrey)};
    white-space: nowrap;
    ${media.mobileM`
      white-space: pre-wrap;
    `}
  }
  // ${media.tablet`
  //   min-width: auto;
  //   margin-right: 48px;
  //   padding: 4px 0;
  //   border: none;
  //   > h4 {
  //     display: block;
  //     font-size: ${theme.fonts.size.small};
  //   }
  //   &:last-child {
  //     margin: 0;
  //     padding: 0 16px 0 0;
  //   }
  //   &::before {
  //     content: '';
  //     ${props => props.icon && css`
  //       content: '${props.icon}';
  //     `}
  //     color: ${theme.color.lightGrey};
  //     font-family: 'Font Awesome 5 Pro';
  //     font-size: ${theme.fonts.size.normal};
  //   }
  // `}
  ${props => props.active && css`
    background-color: ${theme.color.primaryColor};
    > h4 {
      color: ${theme.color.offWhite};
    }
    // ${media.tablet`
    //   background-color: transparent;
    //   &::before {
    //     color: ${theme.color.primaryColor};
    //   }
    //   > h4 {
    //     color: ${theme.color.primaryColor};
    //   }
    // `}
  `}
`

export default TabContainerWrapper



// WEBPACK FOOTER //
// ./src/pages/member/styled.js